import { cn } from "../../../lib/utils/cn";

interface PageCountProps {
  currentPage: number;
  totalCount: number;
  className?: string;
}

export default function PageCount({
  currentPage,
  totalCount,
  className,
}: PageCountProps) {
  return (
    <div className={cn("flex-row gap-[5px]", className)}>
      {Array.from({ length: totalCount }, (_, index) => {
        return (
          <div
            key={index}
            className={cn(
              "size-6 rounded-full text-center font-[500] flex items-center justify-center text-white text-sm",
              index + 1 == currentPage
                ? "bg-[#222]"
                : index + 1 > currentPage
                  ? "bg-[#e6e6e6]"
                  : "bg-primary",
            )}
          >
            {index + 1 >= currentPage ? (
              <span>{index + 1}</span>
            ) : (
              <img
                className="w-2.5 h-auto object-contain"
                src="/icons/ic-check.webp"
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
